import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { SalesOrderService } from 'application/patient/services';
import { toDate } from 'core/utils';
import _ from 'lodash';

@applicationContext
class PatientSalesOrderListViewStore extends BaseListViewStore {
    constructor(rootStore) {

        const service = new SalesOrderService(rootStore.application.baasic.apiClient);
        const routeParams = rootStore.routerStore.routerState.params;
        
        super(rootStore, {
            name: 'patient',
            autoInit: true,
            routes: {
                 preview: item => {
                    this.rootStore.routerStore.setTransitionData({
                        navigationTitle: routeParams.firstName + ' ' + routeParams.lastName 
                    });
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.patient.preview.orders.preview',
                        _.extend(routeParams, {orderId: item.orderId})
                    )
                }
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.find(_.extend(params, {patientId: this.rootStore.routerStore.routerState.params.id}));
                        var mapped = _.each(response.data.item, item => ({
                            orderId: item.brightreeId,
                            salesOrderItems: item.salesOrderItems,
                            reference: item.salesOrderGeneralInfo.reference
                        }));
                        var mappedData = [];
                        _.each(mapped, function(item){
                             var mappedItem = _.each(item.salesOrderItems, i => (
                                _.extend(i, {
                                    orderId: item.brightreeId,
                                    reference: item.salesOrderGeneralInfo.reference,
                                    serviceDate: toDate(i.serviceDate)
                                })));
                            mappedData = _.union(mappedData, mappedItem); 
                        });
                        response.data.item = mappedData;
                        return response.data;
                    }
                }
            }
        });

         this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: [
                {
                    key: 'orderId',
                    title: 'ORDERS.LIST.COLUMNS.ORDER_ID',
                    sort: false,
                }, 
                {
                    key: 'serviceDate',
                    title: 'ORDERS.LIST.COLUMNS.DATE_OF_SERVICE',
                    sort: false,
                },
                {
                    key: 'reference',
                    title: 'Reference',
                    sort: false,
                },
                 {
                    key: 'procCode',
                    title: 'ORDERS.LIST.COLUMNS.PROCEDURE_CODE',
                    sort: false,
                }, 
                {
                    key: 'itemId',
                    title: 'ORDERS.LIST.COLUMNS.ITEM_ID',
                    sort: false,
                },
                {
                    key: 'itemName',
                    title: 'ORDERS.LIST.COLUMNS.ITEM_NAME',
                    sort: false,
                    width: 300
                }, 
                {
                    key: 'quantity',
                    title: 'ORDERS.LIST.COLUMNS.QUANTITY',
                    sort: false,
                },
                {
                    key: 'note',
                    title: 'ORDERS.LIST.COLUMNS.NOTE',
                    sort: false,
                }  
            ],
            actions: {
               onPreview: (item) => this.routes.preview(item)
           }
        }));
    }
}

export default PatientSalesOrderListViewStore;
